<div class="promo-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.promo_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.promo_title' | translate }}</h2>
    </div>
    <button (click)="EmptyForm()" class="lx-btn lx-btn--primary" data-bs-toggle="modal" data-bs-target="#addPromo">
      <span class="material-symbols-outlined">add</span>
      {{ 'btn.add_promo' | translate }}
    </button>
  </div>

  <div class="app-card promo-table-card">
    <div class="lx-table-wrap">
      <table class="lx-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.code' | translate }}</th>
            <th>{{ 'lbl.discount' | translate }}</th>
            <th>{{ 'lbl.limit' | translate }}</th>
            <th class="promo-actions-head">{{ 'lbl.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of allPromoCode">
            <td class="cell-muted">{{ item.id }}</td>
            <td (click)="Details(item)" class="promo-code-cell">
              <span class="promo-code-chip">{{ item.promo_code }}</span>
            </td>
            <td>
              <span class="status-badge paid">{{ item.percentage }}%</span>
            </td>
            <td>{{ item.limit }}</td>
            <td class="promo-actions-cell">
              <button class="lx-icon-btn"
                data-bs-toggle="modal"
                (click)="editPromocode(item)"
                data-bs-target="#editPromo"
                [title]="'btn.edit' | translate">
                <span class="material-symbols-outlined">edit</span>
              </button>
              <button class="lx-icon-btn lx-icon-btn--danger"
                data-bs-toggle="modal"
                (click)="deletePromo(item)"
                data-bs-target="#Delete"
                [title]="'btn.delete' | translate">
                <span class="material-symbols-outlined">delete</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lx-empty" *ngIf="allPromoCode.length === 0">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">confirmation_number</span>
      </div>
      <h3>{{ 'empty.promo' | translate }}</h3>
      <p>{{ 'empty.promo_sub' | translate }}</p>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Add Promo Modal
════════════════════════════════════════ -->
<div class="modal fade" id="addPromo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.promo_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'promo.add_title' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <form>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.code_name' | translate }}</label>
            <input [(ngModel)]="promo_code" name="code" type="text" class="lx-input" [placeholder]="'ph.promo_code' | translate" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.percentage_label' | translate }}</label>
            <input [(ngModel)]="percentage" name="percentage" type="number" class="lx-input" placeholder="20" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.limit_label' | translate }}</label>
            <input [(ngModel)]="limit" name="limit" type="number" class="lx-input" placeholder="100" />
          </div>
        </form>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="addPromo()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.create_code' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Edit Promo Modal
════════════════════════════════════════ -->
<div class="modal fade" id="editPromo" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.promo_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'promo.edit_title' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <form>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.code_name' | translate }}</label>
            <input [(ngModel)]="promo_code" name="code" type="text" class="lx-input" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.percentage_label' | translate }}</label>
            <input [(ngModel)]="percentage" name="percentage" type="number" class="lx-input" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'promo.limit_label' | translate }}</label>
            <input [(ngModel)]="limit" name="limit" type="number" class="lx-input" />
          </div>
        </form>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="confirmEdit()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_changes' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ══════════════════════════════════════
     Delete Promo Modal
════════════════════════════════════════ -->
<div class="modal fade" id="Delete" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--centered">
        <div class="lx-modal-icon lx-modal-icon--danger">
          <span class="material-symbols-outlined">delete_forever</span>
        </div>
        <h5 class="lx-modal-title">{{ 'promo.delete_title' | translate }}</h5>
        <p class="lx-modal-subtitle">
          {{ 'confirm.are_you_sure_delete' | translate }} <strong>{{ promoName }}</strong>?
          {{ 'confirm.cannot_undo' | translate }}
        </p>
      </div>
      <div class="lx-modal-footer lx-modal-footer--centered">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button (click)="delete()" type="button" data-bs-dismiss="modal" class="lx-btn lx-btn--danger">
          <span class="material-symbols-outlined">delete</span>
          {{ 'btn.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
